import { getRequiredSlots } from '../gphSkillRegistry';

const GAME_ALIASES = {
  pubg: 'pubg_mobile',
  pubgm: 'pubg_mobile',
  'pubg mobile': 'pubg_mobile',
  freefire: 'free_fire',
  'free fire': 'free_fire',
  ff: 'free_fire',
  cod: 'codm',
  codm: 'codm',
  'cod mobile': 'codm',
  'call of duty mobile': 'codm',
  'call of duty: mobile': 'codm'
};

const GOAL_ALIASES = {
  gameplay: 'gameplay',
  partida: 'gameplay',
  replay: 'replay',
  video: 'gameplay',
  x1: 'x1',
  duelo: 'x1',
  aim: 'aim',
  mira: 'aim',
  recoil: 'aim',
  movement: 'movement',
  movimentacao: 'movement',
  movimentação: 'movement',
  cover: 'movement'
};

const SUPPORTED_GAMES = new Set(['pubg_mobile', 'free_fire', 'codm', 'other']);
const SUPPORTED_GOALS = new Set(['gameplay', 'replay', 'x1', 'aim', 'movement']);

const stripAccents = (value = '') =>
  String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const cleanToken = (value = '') => stripAccents(value).replace(/[^a-z0-9:_]+/g, ' ').trim();

const normalizeGame = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const cleaned = cleanToken(raw);
  return GAME_ALIASES[cleaned] || raw;
};

const normalizeGoal = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const cleaned = cleanToken(raw);
  return GOAL_ALIASES[cleaned] || raw;
};

const isVideoLike = (value) => (
  Boolean(value)
  && (
    typeof File !== 'undefined' && value instanceof File
      ? true
      : typeof value === 'object' && !Array.isArray(value) && Boolean(value.name || value.fileName || value.type)
  )
);

export const normalizeMiAnalysisSlots = (slots = {}, host = {}) => {
  const normalized = { ...slots };
  normalized.game = normalizeGame(normalized.game || normalized.gameId || host.canonicalGame);
  normalized.analysisGoal = normalizeGoal(normalized.analysisGoal || normalized.goal || normalized.validationGoal);
  normalized.video = normalized.video || normalized.file || host.selectedVideo || null;
  normalized.notes = String(normalized.notes || normalized.context || '').trim().slice(0, 1000);
  return normalized;
};

export const validateMiAnalysisSlots = (slots = {}, host = {}) => {
  const normalizedSlots = normalizeMiAnalysisSlots(slots, host);
  const required = getRequiredSlots('mi_analysis');
  const missingSlots = [];
  const invalidSlots = [];

  if (required.includes('analysisGoal') && !normalizedSlots.analysisGoal) {
    missingSlots.push('analysisGoal');
  }

  if (required.includes('video') && !isVideoLike(normalizedSlots.video)) {
    missingSlots.push('video');
  }

  if (normalizedSlots.game && !SUPPORTED_GAMES.has(normalizedSlots.game)) {
    invalidSlots.push({ slot: 'game', value: normalizedSlots.game, reason: 'unsupported_game' });
  }

  if (normalizedSlots.analysisGoal && !SUPPORTED_GOALS.has(normalizedSlots.analysisGoal)) {
    invalidSlots.push({ slot: 'analysisGoal', value: normalizedSlots.analysisGoal, reason: 'unsupported_analysis_goal' });
  }

  return {
    valid: missingSlots.length === 0 && invalidSlots.length === 0,
    normalizedSlots,
    missingSlots,
    invalidSlots
  };
};

export const buildMissingMiAnalysisSlotsMessage = (missingSlots = []) => {
  const missing = new Set(missingSlots);
  if (missing.has('analysisGoal') && missing.has('video')) {
    return 'Me diga o que voce quer analisar e envie o video da jogada. Sem video eu nao consigo validar visualmente.';
  }
  if (missing.has('analysisGoal')) {
    return 'O que voce quer que eu analise no video: mira, movimentacao, X1 ou gameplay geral?';
  }
  if (missing.has('video')) {
    return 'Me envia o video da jogada para eu analisar de verdade. Sem video, eu posso orientar por relato, mas nao validar visualmente.';
  }
  return 'Preciso de mais um detalhe para iniciar a Mi Analise.';
};

export const buildInvalidMiAnalysisSlotsMessage = (invalidSlots = []) => {
  const first = invalidSlots[0];
  if (!first) return null;

  if (first.reason === 'unsupported_game') {
    return 'Para Mi Analise, me diga PUBG Mobile, Free Fire ou COD Mobile.';
  }

  if (first.reason === 'unsupported_analysis_goal') {
    return 'Consigo analisar mira, movimentacao, X1, replay ou gameplay geral. Qual desses focos voce quer?';
  }

  return 'Nao consegui validar os dados da Mi Analise. Me diga o objetivo e envie o video.';
};

export default validateMiAnalysisSlots;
